import { Exposure, TerrainExposureCategory, ThermalCondition } from '@paragon/contract-library';

export const terrainCategories: readonly TerrainExposureCategory[] = [
  'B_SuburbanAreas',
  'C_ScatteredObstructions',
  'D_FlatOpenTerrain',
];
export const exposureCategories: readonly Exposure[] = ['FullyExposed', 'PartiallyExposed', 'Sheltered'];
export const thermalConditions: readonly ThermalCondition[] = [
  'Other',
  'ColdVented',
  'Unheated',
  'FreezerBuilding',
  'Greenhouse',
];
